import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Recognize user language
  .use(initReactI18next) // Build in react
  .init({
    lng: 'en', // Default language
    fallbackLng: 'en', // Default language
    debug: true, // Console output for debugging
    interpolation: {
      escapeValue: false, // React already does escaping
    }
});

export default i18n;